/*
 * moduleName: 学生列表默认数据
 * description:
 */
import * as actionTypes from '../actionType';

const defalutState = {
  defaultStudentListPayload: {},
  studentListFilterList: {},
  selectAutoSysCommodityListObject: {},
  selectPlanContentParams: {},
  selectPlanContentParamsListObject: {}
};
export default {
  defaultStudentListPayload(state = defalutState.defaultStudentListPayload, action, getState) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_STUDENTLISTPAYLOAD:
        return payload;
      default:
    }

    return state;
  },
  studentListFilterList(state = defalutState.studentListFilterList, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_STUDENT_LIST_FILTER_LIST:
        return payload;
      default:
    }

    return state;
  },
  selectAutoSysCommodityListObject(state = defalutState.selectAutoSysCommodityListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SELECTED_AUTO_SYS_COMMODITY_LIST_OBJECT:
        return payload;
      default:
    }

    return state;
  },
  selectPlanContentParams(state = defalutState.selectPlanContentParams, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SELECT_PLAN_CONTENT_PARAMS:
        return payload;
      default:
    }

    return state;
  },
  selectPlanContentParamsListObject(state = defalutState.selectPlanContentParamsListObject, action) {
    const { type, payload } = action;
    switch (type) {
      case actionTypes.SET_SELECT_PLAN_CONTENT_LIST_OBJECT:
        return payload;
      default:
    }

    return state;
  },
};
